import React, { useContext, useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { Link, useNavigate } from "react-router-dom";
import SliderContainer from "./components/SliderContainer";
import Banner from "./components/Banner";
import CategoryGrid from "./components/CategoryGrid";
import axios from "axios";
import { AuthContext, base_url } from "../context/Authcontext";
import '../../src/assets/AdminCss/card.css';
import ScrollableContent from "./components/ScrollableContent";
import Cricket from "./Cricket";
import toast from "react-hot-toast";
import pLimit from 'p-limit';
import TopBar from "./components/TopNavbar";
import CarouselF from "./components/CarouselF";
import Racing from "./components/Racing";
import MarqueeBottom from "./components/MarqueeBottom";
import { useTheme } from "../context/ThemeContext";


const formatDate = (dateString) => {

  if (!dateString) return null;

  const dateObj = new Date(dateString);
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`; // Only date (YYYY-MM-DD)
};


const compareWithToday = (eventDate, allEvents) => {
  const now = new Date();
  const eventDateObj = new Date(eventDate);

  // Convert both to local date strings (YYYY-MM-DD) for comparison
  const todayDate = now.toISOString().split("T")[0];
  const eventDateFormatted = eventDateObj.toISOString().split("T")[0];

  // Get time in minutes since midnight
  const currentMinutes = getMinutesSinceMidnight(now);
  const eventMinutes = getMinutesSinceMidnight(eventDateObj);

  // Calculate 7 hours ago in minutes
  const sevenHoursAgo = currentMinutes - 420; // 7 * 60 minutes

  // Ensure the event is today
  if (todayDate !== eventDateFormatted) {
    return false;
  }

  // Return true if the event is within the range from 7 hours ago to the end of today
  return eventMinutes >= sevenHoursAgo;
};

const getMinutesSinceMidnight = (date) => {
  return date.getUTCHours() * 60 + date.getUTCMinutes(); // Ensures UTC time handling
};





const Inplay = ({ data }) => {
  const { isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();
  const [cricket, setCricket] = useState([]);
  const [avail, setAvail] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedBet, setSelectedBet] = useState(0);
  const [backActive, setbackActive] = useState(0);
  const [layActive, setlayActive] = useState(0);
  const [money, setMoney] = useState(0);
  const [pr, setPr] = useState(0);
  const [selectedPrice, setSelectedPrice] = useState(0);
  const [side, setSide] = useState('');
  const [active, setActive] = useState(false);
  const [selectedMatch, setSelectedMatch] = useState('');
  const [selectionid, setSelectionid] = useState();
  const [runner, setRunner] = useState();
  const [competition, setCompetition] = useState();
  const [eventid, setEventid] = useState();
  const [eventname, setEventname] = useState();
  const [profit, setProfit] = useState(0);
  const [time, setTime] = useState();
  const [lockedMatch, setLockedMatch] = useState([]);
  const [lockedMatchesLoaded, setLockedMatchesLoaded] = useState(false); // NEW
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 991);
  const { themeColors } = useTheme();

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 991);
    };

    window.addEventListener('resize', handleResize);

    // Cleanup on unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  // console.log("locked matched s", lockedMatch);

  // Step 1: Load locked matches
  const matchDatabaseData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(base_url + '/api/webapi/matchDatabaseData', {
        headers: { "Content-Type": "application/json" },
      });
      setLockedMatch(response.data.data);
      setLockedMatchesLoaded(true); // Set as loaded
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  }

  // console.log("locked match" , lockedMatch)


  const matchData = async () => {
    // console.log("sbjhjhbkhbkj")
    setLoading(true);
    try {
      const response = await axios.get(
        base_url + '/api/webapi/matchapi',
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = response?.data.result;

      // console.log("data is snsijisjk", data);

      // Step 1: Get array of locked event IDs
      const lockedEventIds = lockedMatch.map(match => match.eventid);

      // console.log("locked event ids" , lockedEventIds)
      // Step 2: Extract and filter data
      const allOpenDates = data?.map(dta => dta?.event.openDate);

      const allData = [];
      data?.forEach((dta) => {
        const openDate = dta?.event?.openDate;
        const eventId = dta?.event?.id;

        // console.log("event id ", eventId);

        // Only add if not locked AND date condition passes
        const isLocked = lockedEventIds.includes(eventId);
        // console.log("is locked ", eventId, isLocked);
        const isValidDate = compareWithToday(openDate, allOpenDates);

        if (!isLocked && isValidDate) {
          allData.push(dta);
        }

        // console.log("data is ", dta);
        // console.log("All Data  ", allData);
      });

      setCricket(allData);
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  // const showLogo = async () => {
  //   console.log("logologologologologologo")
  //   setLoading(true);
  //   try {
  //     const response = await axios.get(
  //       base_url + '/api/webapi/fetchLogoAction',
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     const data = response;

  //     console.log("data is logologologo", data);

  //   } catch (error) {
  //     console.error("API Error:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  // useEffect(() => {
  //   showLogo()
  // },[])


  const footballData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(base_url + '/api/webapi/footballapi', {
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = response?.data.result;

      // Get locked event IDs
      const lockedEventIds = lockedMatch.map(match => match.eventid);

      const allOpenDates = data?.map(dta => dta?.event.openDate);

      const allData = [];
      data?.forEach((dta) => {
        const openDate = dta?.event.openDate;
        const eventId = dta?.event?.id;

        const isLocked = lockedEventIds.includes(eventId);
        const isValidDate = compareWithToday(openDate, allOpenDates);

        if (!isLocked && isValidDate) {
          allData.push(dta);
        }
      });

      setCricket(allData);
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };


  const tennisData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(base_url + '/api/webapi/tennisapi', {
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = response?.data.result;

      // Get locked event IDs
      const lockedEventIds = lockedMatch.map(match => match.eventid);

      const allOpenDates = data?.map(dta => dta?.event.openDate);

      const allData = [];
      data?.forEach((dta) => {
        const openDate = dta?.event.openDate;
        const eventId = dta?.event?.id;

        const isLocked = lockedEventIds.includes(eventId);
        const isValidDate = compareWithToday(openDate, allOpenDates);

        if (!isLocked && isValidDate) {
          allData.push(dta);
        }
      });

      setCricket(allData);
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };


  const [formData, setFormData] = useState({
    competiton: '',
    eventname: '',
    eventid: 0,
    marketId: '',
    selectionId: 0,
    runnername: '',
    betPrice: 0,
    type: 'odds',
    betAmount: 0,
    profit: 0,
    side: '',
    status: 0,
  });

  function formatDate(isoString) {
    const date = new Date(isoString);
    return date.toLocaleString("en-US", {
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true
    });
  }


  const handlelayChange = (action) => {
    setSelectedPrice((prev) => {
      let newMoney = prev < 1.01 ? 1.01 : prev;

      if (action === 0) {
        return Math.max(0, (parseFloat(newMoney) - 0.01).toFixed(2));
      } else {
        return (parseFloat(newMoney) + 0.01).toFixed(2);
      }
    });
  };

  const handleChange = (action) => {
    // console.log('act',action);

    setMoney((prevMoney) => {
      let newMoney = prevMoney < 0 ? 0 : prevMoney;

      if (action === 0) {
        return Math.max(0, parseFloat(newMoney) - 100);
      } else {
        return parseFloat(newMoney) + 100;
      }
    });
  };

  const handleBetClick = async (item, index, marketid) => {
    // console.log(item);
    // console.log(index); 
    // console.log(marketid); 
    try {

      const match = cricket.find(cric => cric.marketId === marketid);
      const runners = match.runners;
      setEventid(match?.event.id);
      setEventname(match?.event.name);
      setCompetition(match?.competition.name);
      const time = formatDate(match?.event.openDate);
      setTime(time);
      // console.log(match);

      if (index < 2) {
        setSelectionid(runners[0].selectionId);
        setRunner(runners[0].runnerName);
      } else {
        setSelectionid(runners[1].selectionId);
        setRunner(runners[1].runnerName);
      }

      if (item?.type === 'Back') {
        // console.log('back called');
        setbackActive(1);
        setlayActive(0);
        setSide(item.type);
        setSelectedBet(index);
        setSelectedPrice(item.price);
        setSelectedMatch(marketid);
      }

      else if (item?.type === 'Lay') {
        // console.log('lay called');
        setlayActive(1);
        setbackActive(0);
        setSide(item.type);
        setSelectedBet(index);
        setSelectedPrice(item.price);
        setSelectedMatch(marketid);
      }

    } catch (err) {
      console.log(err);
    }
  }
  // console.log(selectionid, runner);

  function isTenMinutesRemaining(isoString) {
    const targetTime = new Date(isoString).getTime(); // Convert given time
    const currentTime = new Date().getTime(); // Get current time

    // Calculate the difference in milliseconds
    const timeDifference = targetTime - currentTime;

    // Convert milliseconds to minutes
    const minutesRemaining = timeDifference / (1000 * 60);

    return minutesRemaining > 10;
  }


  const handleSubmit = async () => {

    if (!isAuthenticated) {
      setActive(true);
      return;
    }
    // if(isTenMinutesRemaining(time)){
    //   toast.error('Off Bets! Bets placed only before ten minutes');
    //   return;
    // }

    if (money < 100) {
      toast.error("Bet cant be placed less than Rs.100");
      return;
    }

    if (selectedPrice < 1) {
      toast.error("Bet selectedprice is less");
      return;
    }

    // console.log('form',formData);

    try {
      const response = await axios.post(base_url + '/api/webapi/sportsData',
        formData,
        {
          withCredentials: true,
          headers: {
            'content-type': 'application/json',
          }
        }
      );

      console.log('formmatch', response);

      if (response?.data.success) {
        toast.success(response?.data.message);
      } else {
        toast.error(response?.data.message);
      }
      // window.location.reload();
    } catch (err) {
      console.log(err);
      toast.error("Failed to place bet");
    }


  };

  const handleClick = (item) => {
    console.log(item);

    sessionStorage.setItem('marketId', item.marketId);
    sessionStorage.setItem('competetionid', item.competition.id);
    sessionStorage.setItem('eventid', item.event.id);
    sessionStorage.setItem('time', item?.event.openDate);
    sessionStorage.setItem('competitionname', item?.competition.name);
    sessionStorage.setItem('eventname', item?.event.name);

    if (item.eventType.name === "Cricket") {
      navigate('/cricketBet');
      sessionStorage.setItem('selectionid1', item?.runners[0].selectionId);
      sessionStorage.setItem('selectionid2', item?.runners[1].selectionId);

      sessionStorage.setItem('runner1', item.runners[0].runnerName);
      sessionStorage.setItem('runner2', item.runners[1].runnerName);


    } else if (item.eventType.name === "Soccer") {
      navigate('/footBAllBet');
      sessionStorage.setItem('selectionid1', item?.runners[0].selectionId);
      sessionStorage.setItem('selectionid2', item?.runners[1].selectionId);
      sessionStorage.setItem('selectionid3', item?.runners[2].selectionId);

      sessionStorage.setItem('runner1', item.runners[0].runnerName);
      sessionStorage.setItem('runner2', item.runners[1].runnerName);
      sessionStorage.setItem('runner3', item.runners[2].runnerName);

    } else if (item.eventType.name === "Tennis") {
      navigate('/tennis');
      sessionStorage.setItem('selectionid1', item?.runners[0].selectionId);
      sessionStorage.setItem('selectionid2', item?.runners[1].selectionId);

      sessionStorage.setItem('runner1', item.runners[0].runnerName);
      sessionStorage.setItem('runner2', item.runners[1].runnerName);

    }


  }

  // Step 2: Load match data only after locked matches are loaded
  useEffect(() => {
    matchDatabaseData(); // Runs once on mount
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (!lockedMatchesLoaded) return; // Wait until locked matches are loaded

      if (data === 0) {
        await matchData();
      } else if (data === 1) {
        await footballData();
      } else if (data === 2) {
        await tennisData();
      }
    };

    fetchData();
  }, [data, lockedMatchesLoaded]);// Only when 'data' changes

  // 2. When cricket is updated, then call odds API
  useEffect(() => {
    const oddsData = async () => {
      if (cricket.length === 0) return;

      try {
        const marketid = cricket.map(item => item.marketId);

        const response = await axios.post(
          `${base_url}/api/webapi/market/wholeMarket`,
          marketid,
          {
            headers: {
              "Content-Type": "application/json",
            },
            timeout: 10000,
          }
        );

        const result = JSON.parse(response.data); // Remove JSON.parse if response is already JSON
        setAvail(result);
      } catch (err) {
        console.error("Error fetching odds data:", err);
      }
    };

    oddsData();
  }, [cricket]);

  // 3. Calculate profit separately
  useEffect(() => {
    if (!isNaN(selectedPrice) && !isNaN(money)) {
      const proft = (parseFloat(selectedPrice) * parseFloat(money)) - parseFloat(money);
      setProfit(proft.toFixed(1));
    }
  }, [selectedPrice, money]); // Only update when those change


  // console.log('vall',cricket);

  formData.competiton = competition;
  formData.eventid = eventid;
  formData.eventname = eventname;
  formData.marketId = selectedMatch;
  formData.selectionId = selectionid;
  formData.runnername = runner;
  formData.betPrice = selectedPrice;
  formData.betAmount = money;
  formData.side = side;
  formData.profit = profit;
  // console.log(avail);
  // console.log(avail);

  return (
    <>

      <div _ngcontent-jrx-c94="" className="wrap-conatiner">
        <div _ngcontent-jrx-c94="">
          <div
            _ngcontent-jrx-c94=""
            className="section tabs_boxes_section px-1 no-pad-bot no-pad-top"
          >
            <div _ngcontent-jrx-c94="" className="">
              <div _ngcontent-jrx-c94="" className="sports-wrapper">

                {/* <div style={{ backgroundColor: "var(--dark-theme-time-remaining)" }}>
                  <h6 className="mb-0 fw-bold py-1 ps-2">Cricket</h6>
                </div> */}
                {isLargeScreen && (cricket.length > 0 ? (
                  cricket.filter(
                    (item) =>
                      avail[item.marketId] &&
                      avail[item.marketId].length > 0 &&
                      avail[item.marketId].some(
                        (market) =>
                          (market?.ex?.availableToBack?.length > 0 || market?.ex?.availableToLay?.length > 0)
                      )
                  ).map((item, index) => {
                    const marketData = avail[item.marketId] || [];
                    // console.log('arrAnsu',item);
                    const marketid = item.marketId;

                    return (
                      <>
                        <div
                          key={index}
                          _ngcontent-jrx-c94=""
                          id={item?.competition?.id}
                          className="flex-md-row justify-content-between ng-star-inserted"
                          style={{ position: "relative" }}
                        >
                          <div>
                            {/* <p>{item.marketId}</p> */}
                            <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="section_details_box upcoming-data"
                              >

                                {item.isStarted && (
                                  <span
                                    _ngcontent-jrx-c94=""
                                    className="innerHTMLScore upcoming-score ng-star-inserted"
                                  >
                                    <div className="cricket-info">
                                      <div className="score"
                                      >
                                        <span>
                                          item2
                                          <span className="vOver">(45.0)</span>
                                        </span>
                                        <span className="vRun">
                                          0 - 0 - 0 - 0 - 1 - 0 -{" "}
                                        </span>
                                        <span>
                                          item
                                          <span className="vOver">(0.0)</span>
                                        </span>
                                      </div>
                                    </div>
                                  </span>
                                )}

                                <div
                                  _ngcontent-jrx-c94=""
                                  className="sport-type-detail"
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="runnners-odds-details"
                                  >
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="sport-name-wrapper"
                                    >
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="details_box_team py-0 my-0"
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="details_box_t_name d-flex t_left fs-4"
                                          onClick={() => handleClick(item)}
                                        >
                                          <span style={{ color: 'var(--dark-theme-data-color)' }} className="fszz">{/*new Date(item?.event.openDate).toISOString().split("T")[0]*/}Today</span>   <span style={{ color: 'var(--dark-theme-data-color)' }} className="fszz">{new Date(item?.event.openDate).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false })} </span> <span className="px-1">|</span>
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className={`${new Date() >= new Date(item?.event.openDate)
                                              ? "green-circle inplay-blinker ng-star-inserted mx-1"
                                              : ""
                                              }`}
                                          ></div> {" "}
                                          {item.runners[0].runnerName}{" "}
                                          <span
                                            _ngcontent-jrx-c94=""
                                            className="vs ng-star-inserted"
                                          >
                                            {" "}
                                            vs{" "}
                                          </span>
                                          {item.runners[1].runnerName}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="d-flex  p-0">
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="middle-detail"
                                      >
                                        {/* <div
                                          _ngcontent-jrx-c94=""
                                          className={`${new Date() >= new Date(item?.event.openDate)
                                            ? "green-circle inplay-blinker ng-star-inserted"
                                            : ""
                                            }`}
                                        ></div> */}
                                        <img
                                          _ngcontent-jrx-c94=""
                                          className="small-grid ng-star-inserted"
                                          style={{ height: "18px", width: "18px" }}
                                          src="/assets/paneal_images/tv (1).png"
                                          alt="TVKheloyaar360"
                                        />

                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="small-grid"
                                        >
                                          <span _ngcontent-jrx-c94="">
                                            <img className="imgfluid" src="/assets/images/bm-icon1.svg" />
                                          </span>
                                          <span _ngcontent-jrx-c94="">
                                            <img className="imgfluid ms-1" src="assets/images/fancy-icon1.svg" />
                                          </span>
                                        </div>

                                      </div>
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="details_odds_boxes_inn details_small_box_wrapper"
                                        style={{ position: "relative", paddingTop: "2px" }}
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="details_small_boxes"
                                        >
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="details_small_boxes_let"
                                          >
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_small_boxes_inn ng-star-inserted"
                                            >

                                              {marketData && marketData.length > 0 && (
                                                <div className="d-flex runnners-odds-details">
                                                  {(() => {
                                                    let backDivs = marketData.flatMap(market =>
                                                      market?.ex?.availableToBack?.length > 0
                                                        ? [{ price: market.ex.availableToBack[0].price, type: "Back" }]
                                                        : []
                                                    );
                                                    let layDivs = marketData.flatMap(market =>
                                                      market?.ex?.availableToLay?.length > 0
                                                        ? [{ price: market.ex.availableToLay[0].price, type: "Lay" }]
                                                        : []
                                                    );

                                                    // Fill up with empty divs if needed to ensure 6 elements
                                                    while (backDivs.length < 2) backDivs.push({ price: null, type: "Back" });
                                                    while (layDivs.length < 2) layDivs.push({ price: null, type: "Lay" });

                                                    let combinedDivs = [
                                                      backDivs[0],
                                                      layDivs[0],
                                                      { price: null, type: "Back" },
                                                      { price: null, type: "Lay" },
                                                      backDivs[1],
                                                      layDivs[1],
                                                    ];

                                                    return combinedDivs.map((item, index) => (
                                                      <app-oddsbutton key={index}>
                                                        <div
                                                          id={index}
                                                          className={`d-md-flex d-none d-sm-none details_small_blue_box odds-box`}
                                                          style={{
                                                            backgroundColor: item.type === "Lay"
                                                              ? themeColors['--dark-theme-data-box2'] : themeColors['--dark-theme-data-box'], 
                                                          }}

                                                          // onClick={() => handleBetClick(item, index, marketid)}
                                                        >
                                                          <span className="ng-star-inserted">
                                                            {item.price !== null ? item.price : "--"}
                                                          </span>
                                                        </div>
                                                      </app-oddsbutton>
                                                    ));
                                                  })()}
                                                </div>
                                              )}

                                            </div>
                                          </div>
                                          <div
                                            _ngcontent-jrx-c94=""
                                            style={{ clear: "both" }}
                                          ></div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* betting back div */}
                          {(backActive === 1 && side === 'Back' && selectedMatch === marketid) && (
                            <div style={{ backgroundColor: "#052e36", padding: "15px", color: "white", borderRadius: "5px", width: "100%" }} className="homebet">
                              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                                <button
                                  style={{ backgroundColor: "#0A6E8A", color: "white", padding: "8px 20px", border: "none", borderRadius: "5px", fontWeight: "bold" }}
                                  onClick={() => {
                                    setbackActive(0);
                                    setMoney(0);
                                    setPr(0);
                                  }}
                                >
                                  BACK
                                </button>
                                <div style={{ color: "#4ADE80", fontWeight: "bold" }}>
                                  Profit: {(money * (selectedPrice - 1)).toFixed(1)}
                                </div>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                  <input type="checkbox" style={{ width: "18px", height: "18px", marginRight: "8px" }} id="matchAtAnyRate" />
                                  <label htmlFor="matchAtAnyRate">Match At Any Rate</label>
                                </div>
                              </div>

                              <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginBottom: "15px" }}>
                                <div className="w-25" style={{ flex: 1 }}>
                                  <div style={{ textAlign: "center", marginBottom: "5px" }}>Odds</div>
                                  <div style={{ display: "flex", height: "40px" }}>
                                    <button
                                      style={{ backgroundColor: "#064150", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                      onClick={() => handlelayChange(0)}
                                    >−</button>
                                    <input
                                      type="text"
                                      value={selectedPrice}
                                      onChange={(e) => setSelectedPrice(e.target.value)}
                                      style={{ backgroundColor: "#064150", color: "white", border: "none", flex: 1, textAlign: "center", fontSize: "18px", width: "10px" }}
                                    />
                                    <button
                                      style={{ backgroundColor: "#064150", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                      onClick={() => handlelayChange(1)}
                                    >+</button>
                                  </div>
                                </div>
                                <div className="w-25" style={{ flex: 1 }}>
                                  <div style={{ textAlign: "center", marginBottom: "5px" }}>Stake</div>
                                  <div style={{ display: "flex", height: "40px" }}>
                                    <button
                                      style={{ backgroundColor: "#064150", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                      onClick={() => handleChange(0)}
                                    >−</button>
                                    <input
                                      type="text"
                                      value={money}
                                      onChange={(e) => setMoney(e.target.value)}
                                      style={{ backgroundColor: "#064150", color: "white", border: "none", flex: 1, textAlign: "center", fontSize: "18px", width: "10px" }}
                                    />
                                    <button
                                      style={{ backgroundColor: "#064150", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                      onClick={() => handleChange(1)}
                                    >+</button>
                                  </div>
                                </div>
                              </div>

                              <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                                <button
                                  style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(100)}
                                >+ 100</button>
                                <button
                                  style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(200)}
                                >+ 200</button>
                                <button
                                  style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(500)}
                                >+ 500</button>
                                <button
                                  style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(1000)}
                                >+ 1k</button>
                              </div>

                              <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                                <button
                                  style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(5000)}
                                >+ 5k</button>
                                <button
                                  style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(10000)}
                                >+ 10k</button>
                                <button
                                  style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(25000)}
                                >+ 25k</button>
                                <button
                                  style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(50000)}
                                >+ 50k</button>
                              </div>

                              <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                                <button style={{ backgroundColor: "#166534", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Min</button>
                                <button style={{ backgroundColor: "#1e3a8a", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Max</button>
                                <button style={{ backgroundColor: "#7e22ce", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Edit Stake</button>
                                <button
                                  style={{ backgroundColor: "#991b1b", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                  onClick={() => {
                                    setMoney(0);
                                    setPr(0);
                                  }}
                                >Clear</button>
                              </div>

                              <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px" }}>
                                <button
                                  style={{ backgroundColor: "#ef4444", color: "white", padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                  onClick={() => {
                                    setbackActive(0);
                                    setMoney(0);
                                    setPr(0);
                                  }}
                                >Cancel</button>
                                <button
                                  style={{ backgroundColor: "#22c55e", color: "white", padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                  onClick={() => handleSubmit()}
                                >Submit</button>
                              </div>
                            </div>
                          )}



                          {/* betting lay div */}
                          {(layActive === 1 && side === 'Lay' && selectedMatch === marketid) && (
                            <div style={{ backgroundColor: "rgb(29 5 32)", padding: "15px", color: "white", borderRadius: "5px", width: "100%" }} className="homebet">
                              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                                <button
                                  style={{ backgroundColor: "#36013c", color: "white", padding: "8px 20px", border: "none", borderRadius: "5px", fontWeight: "bold" }}
                                  onClick={() => {
                                    setbackActive(0);
                                    setMoney(0);
                                    setPr(0);
                                  }}
                                >
                                  Lay
                                </button>
                                <div style={{ color: "#4ADE80", fontWeight: "bold" }}>
                                  Profit: {(money * (selectedPrice - 1)).toFixed(1)}
                                </div>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                  <input type="checkbox" style={{ width: "18px", height: "18px", marginRight: "8px" }} id="matchAtAnyRate" />
                                  <label htmlFor="matchAtAnyRate">Match At Any Rate</label>
                                </div>
                              </div>

                              <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginBottom: "15px" }}>
                                <div style={{ flex: 1 }}>
                                  <div style={{ textAlign: "center", marginBottom: "5px" }}>Odds</div>
                                  <div style={{ display: "flex", height: "40px" }}>
                                    <button
                                      style={{ backgroundColor: "#36013c", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                      onClick={() => handlelayChange(0)}
                                    >−</button>
                                    <input
                                      type="text"
                                      value={selectedPrice}
                                      onChange={(e) => setSelectedPrice(e.target.value)}
                                      style={{ backgroundColor: "#36013c", color: "white", border: "none", flex: 1, textAlign: "center", fontSize: "18px", width: "10px" }}
                                    />
                                    <button
                                      style={{ backgroundColor: "#36013c", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                      onClick={() => handlelayChange(1)}
                                    >+</button>
                                  </div>
                                </div>
                                <div style={{ flex: 1 }}>
                                  <div style={{ textAlign: "center", marginBottom: "5px" }}>Stake</div>
                                  <div style={{ display: "flex", height: "40px" }}>
                                    <button
                                      style={{ backgroundColor: "#36013c", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                      onClick={() => handleChange(0)}
                                    >−</button>
                                    <input
                                      type="text"
                                      value={money}
                                      onChange={(e) => setMoney(e.target.value)}
                                      style={{ backgroundColor: "#36013c", color: "white", border: "none", flex: 1, textAlign: "center", fontSize: "18px", width: "10px" }}
                                    />
                                    <button
                                      style={{ backgroundColor: "#36013c", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                      onClick={() => handleChange(1)}
                                    >+</button>
                                  </div>
                                </div>
                              </div>

                              <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                                <button
                                  style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(100)}
                                >+ 100</button>
                                <button
                                  style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(200)}
                                >+ 200</button>
                                <button
                                  style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(500)}
                                >+ 500</button>
                                <button
                                  style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(1000)}
                                >+ 1k</button>
                              </div>

                              <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                                <button
                                  style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(5000)}
                                >+ 5k</button>
                                <button
                                  style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(10000)}
                                >+ 10k</button>
                                <button
                                  style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(25000)}
                                >+ 25k</button>
                                <button
                                  style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(50000)}
                                >+ 50k</button>
                              </div>

                              <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                                <button style={{ backgroundColor: "#166534", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Min</button>
                                <button style={{ backgroundColor: "#1e3a8a", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Max</button>
                                <button style={{ backgroundColor: "#7e22ce", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Edit Stake</button>
                                <button
                                  style={{ backgroundColor: "#991b1b", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                  onClick={() => {
                                    setMoney(0);
                                    setPr(0);
                                  }}
                                >Clear</button>
                              </div>

                              <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px" }}>
                                <button
                                  style={{ backgroundColor: "#ef4444", color: "white", padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                  onClick={() => {
                                    setlayActive(0);
                                    setMoney(0);
                                    setPr(0);
                                  }}
                                >Cancel</button>
                                <button
                                  style={{ backgroundColor: "#22c55e", color: "white", padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                  onClick={() => handleSubmit()}
                                >Submit</button>
                              </div>
                            </div>
                          )}
                        </div>
                      </>
                    );
                  })
                ) : (
                   <div className="nomatch">No Matches Found.</div>
                ))}

                {!isLargeScreen && (cricket.length > 0 ? (
                  cricket.filter(
                    (item) =>
                      avail[item.marketId] &&
                      avail[item.marketId].length > 0 &&
                      avail[item.marketId].some(
                        (market) =>
                          (market?.ex?.availableToBack?.length > 0 || market?.ex?.availableToLay?.length > 0)
                      )
                  ).map((item, index) => {
                    const marketData = avail[item.marketId] || [];
                    // console.log('arrAnsu',item);
                    const marketid = item.marketId;

                    return (
                      <>
                        <div
                          key={index}
                          _ngcontent-jrx-c94=""
                          id={item?.competition?.id}
                          className="flex-md-row justify-content-between ng-star-inserted"
                          style={{ position: "relative" }}
                        >
                          <div>
                            {/* <p>{item.marketId}</p> */}
                            <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="section_details_box upcoming-data"
                              >

                                {item.isStarted && (
                                  <span
                                    _ngcontent-jrx-c94=""
                                    className="innerHTMLScore upcoming-score ng-star-inserted"
                                  >
                                    <div className="cricket-info">
                                      <div className="score"
                                      >
                                        <span>
                                          item2
                                          <span className="vOver">(45.0)</span>
                                        </span>
                                        <span className="vRun">
                                          0 - 0 - 0 - 0 - 1 - 0 -{" "}
                                        </span>
                                        <span>
                                          item
                                          <span className="vOver">(0.0)</span>
                                        </span>
                                      </div>
                                    </div>
                                  </span>
                                )}

                                <div
                                  _ngcontent-jrx-c94=""
                                  className="sport-type-detail"
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="runnners-odds-details"
                                  >
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="sport-name-wrapper"
                                    >
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="details_box_team py-0 my-0"
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="details_box_t_name t_left fs-4"
                                          onClick={() => handleClick(item)}
                                        >


                                          {" "}
                                          <span>{item.runners[0].runnerName}{" "}</span>
                                          <span
                                            _ngcontent-jrx-c94=""
                                            className="vs ng-star-inserted"
                                          >
                                            {" "}
                                            vs{" "}
                                          </span>
                                          <span>{item.runners[1].runnerName}</span>
                                          <div className="data_date">
                                            <span style={{ color: 'var(--dark-theme-data-color)' }} className="fszz">Today</span>   <span style={{ color: 'var(--dark-theme-data-color)' }} className="fszz">{new Date(item?.event.openDate).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false })}</span> <span className="px-1">|</span> <span
                                              _ngcontent-jrx-c94=""
                                              className={`${new Date() >= new Date(item?.event.openDate)
                                                ? "green-circle inplay-blinker ng-star-inserted mx-1"
                                                : ""
                                                }`}
                                            ></span>
                                          </div>

                                        </div>
                                      </div>
                                    </div>
                                    <div className="d-flex  p-0">
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="middle-detail"
                                      >
                                        {/* <div
                                          _ngcontent-jrx-c94=""
                                          className={`${new Date() >= new Date(item?.event.openDate)
                                            ? "green-circle inplay-blinker ng-star-inserted"
                                            : ""
                                            }`}
                                        ></div> */}

                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="small-grid"
                                        >
                                          <span _ngcontent-jrx-c94="">
                                            <img className="imgfluid" src="/assets/images/bm-icon1.svg" />
                                          </span>
                                          <span _ngcontent-jrx-c94="">
                                            <img className="imgfluid ms-1" src="assets/images/fancy-icon1.svg" />
                                          </span>
                                        </div>

                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="pin_icon" style={{ border: "1px solid grey", height: "18px", width: "18px" }}
                                        >
                                          <span _ngcontent-jrx-c94="">
                                            <img className="imgfluid" style={{ height: "100%" }} src="/assets/icons/a-pin-mobile.svg" />
                                          </span>
                                        </div>

                                      </div>
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="details_odds_boxes_inn details_small_box_wrapper"
                                        style={{ position: "relative", paddingTop: "2px" }}
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="details_small_boxes"
                                        >
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="details_small_boxes_let"
                                          >
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_small_boxes_inn ng-star-inserted"
                                            >

                                              {marketData && marketData.length > 0 && (
                                                <div className="d-flex runnners-odds-details">
                                                  {(() => {
                                                    let backDivs = marketData.flatMap(market =>
                                                      market?.ex?.availableToBack?.length > 0
                                                        ? [{ price: market.ex.availableToBack[0].price, type: "Back" }]
                                                        : []
                                                    );
                                                    let layDivs = marketData.flatMap(market =>
                                                      market?.ex?.availableToLay?.length > 0
                                                        ? [{ price: market.ex.availableToLay[0].price, type: "Lay" }]
                                                        : []
                                                    );

                                                    // Fill up with empty divs if needed to ensure 6 elements
                                                    while (backDivs.length < 2) backDivs.push({ price: null, type: "Back" });
                                                    while (layDivs.length < 2) layDivs.push({ price: null, type: "Lay" });

                                                    let combinedDivs = [
                                                      backDivs[0],
                                                      layDivs[0],
                                                      { price: null, type: "Back" }, // Empty Back
                                                      { price: null, type: "Lay" }, // Empty Lay
                                                      backDivs[1],
                                                      layDivs[1],
                                                    ];

                                                    return combinedDivs.map((item, index) => (
                                                      <app-oddsbutton key={index}>
                                                        <div
                                                          id={index}
                                                          className={`d-md-flex ${item.type === "Lay" ? "bg-pink1" : ""
                                                            } d-none d-sm-none details_small_blue_box odds-box `}
                                                          // onClick={() => handleBetClick(item, index, marketid)}
                                                        >
                                                          <span className="ng-star-inserted">
                                                            {item.price !== null ? item.price : "--"}
                                                          </span>
                                                        </div>
                                                      </app-oddsbutton>
                                                    ));
                                                  })()}
                                                </div>
                                              )}

                                            </div>
                                          </div>
                                          <div
                                            _ngcontent-jrx-c94=""
                                            style={{ clear: "both" }}
                                          ></div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* betting back div */}
                          {(backActive === 1 && side === 'Back' && selectedMatch === marketid) && (
                            <div style={{ backgroundColor: "#052e36", padding: "15px", color: "white", borderRadius: "5px", width: "100%" }} className="homebet">
                              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                                <button
                                  style={{ backgroundColor: "#0A6E8A", color: "white", padding: "8px 20px", border: "none", borderRadius: "5px", fontWeight: "bold" }}
                                  onClick={() => {
                                    setbackActive(0);
                                    setMoney(0);
                                    setPr(0);
                                  }}
                                >
                                  BACK
                                </button>
                                <div style={{ color: "#4ADE80", fontWeight: "bold" }}>
                                  Profit: {(money * (selectedPrice - 1)).toFixed(1)}
                                </div>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                  <input type="checkbox" style={{ width: "18px", height: "18px", marginRight: "8px" }} id="matchAtAnyRate" />
                                  <label htmlFor="matchAtAnyRate">Match At Any Rate</label>
                                </div>
                              </div>

                              <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginBottom: "15px" }}>
                                <div className="w-25" style={{ flex: 1 }}>
                                  <div style={{ textAlign: "center", marginBottom: "5px" }}>Odds</div>
                                  <div style={{ display: "flex", height: "40px" }}>
                                    <button
                                      style={{ backgroundColor: "#064150", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                      onClick={() => handlelayChange(0)}
                                    >−</button>
                                    <input
                                      type="text"
                                      value={selectedPrice}
                                      onChange={(e) => setSelectedPrice(e.target.value)}
                                      style={{ backgroundColor: "#064150", color: "white", border: "none", flex: 1, textAlign: "center", fontSize: "18px", width: "10px" }}
                                    />
                                    <button
                                      style={{ backgroundColor: "#064150", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                      onClick={() => handlelayChange(1)}
                                    >+</button>
                                  </div>
                                </div>
                                <div className="w-25" style={{ flex: 1 }}>
                                  <div style={{ textAlign: "center", marginBottom: "5px" }}>Stake</div>
                                  <div style={{ display: "flex", height: "40px" }}>
                                    <button
                                      style={{ backgroundColor: "#064150", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                      onClick={() => handleChange(0)}
                                    >−</button>
                                    <input
                                      type="text"
                                      value={money}
                                      onChange={(e) => setMoney(e.target.value)}
                                      style={{ backgroundColor: "#064150", color: "white", border: "none", flex: 1, textAlign: "center", fontSize: "18px", width: "10px" }}
                                    />
                                    <button
                                      style={{ backgroundColor: "#064150", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                      onClick={() => handleChange(1)}
                                    >+</button>
                                  </div>
                                </div>
                              </div>

                              <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                                <button
                                  style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(100)}
                                >+ 100</button>
                                <button
                                  style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(200)}
                                >+ 200</button>
                                <button
                                  style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(500)}
                                >+ 500</button>
                                <button
                                  style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(1000)}
                                >+ 1k</button>
                              </div>

                              <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                                <button
                                  style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(5000)}
                                >+ 5k</button>
                                <button
                                  style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(10000)}
                                >+ 10k</button>
                                <button
                                  style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(25000)}
                                >+ 25k</button>
                                <button
                                  style={{ backgroundColor: "#064150", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(50000)}
                                >+ 50k</button>
                              </div>

                              <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                                <button style={{ backgroundColor: "#166534", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Min</button>
                                <button style={{ backgroundColor: "#1e3a8a", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Max</button>
                                <button style={{ backgroundColor: "#7e22ce", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Edit Stake</button>
                                <button
                                  style={{ backgroundColor: "#991b1b", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                  onClick={() => {
                                    setMoney(0);
                                    setPr(0);
                                  }}
                                >Clear</button>
                              </div>

                              <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px" }}>
                                <button
                                  style={{ backgroundColor: "#ef4444", color: "white", padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                  onClick={() => {
                                    setbackActive(0);
                                    setMoney(0);
                                    setPr(0);
                                  }}
                                >Cancel</button>
                                <button
                                  style={{ backgroundColor: "#22c55e", color: "white", padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                  onClick={() => handleSubmit()}
                                >Submit</button>
                              </div>
                            </div>
                          )}



                          {/* betting lay div */}
                          {(layActive === 1 && side === 'Lay' && selectedMatch === marketid) && (
                            <div style={{ backgroundColor: "rgb(29 5 32)", padding: "15px", color: "white", borderRadius: "5px", width: "100%" }} className="homebet">
                              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                                <button
                                  style={{ backgroundColor: "#36013c", color: "white", padding: "8px 20px", border: "none", borderRadius: "5px", fontWeight: "bold" }}
                                  onClick={() => {
                                    setbackActive(0);
                                    setMoney(0);
                                    setPr(0);
                                  }}
                                >
                                  Lay
                                </button>
                                <div style={{ color: "#4ADE80", fontWeight: "bold" }}>
                                  Profit: {(money * (selectedPrice - 1)).toFixed(1)}
                                </div>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                  <input type="checkbox" style={{ width: "18px", height: "18px", marginRight: "8px" }} id="matchAtAnyRate" />
                                  <label htmlFor="matchAtAnyRate">Match At Any Rate</label>
                                </div>
                              </div>

                              <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginBottom: "15px" }}>
                                <div style={{ flex: 1 }}>
                                  <div style={{ textAlign: "center", marginBottom: "5px" }}>Odds</div>
                                  <div style={{ display: "flex", height: "40px" }}>
                                    <button
                                      style={{ backgroundColor: "#36013c", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                      onClick={() => handlelayChange(0)}
                                    >−</button>
                                    <input
                                      type="text"
                                      value={selectedPrice}
                                      onChange={(e) => setSelectedPrice(e.target.value)}
                                      style={{ backgroundColor: "#36013c", color: "white", border: "none", flex: 1, textAlign: "center", fontSize: "18px", width: "10px" }}
                                    />
                                    <button
                                      style={{ backgroundColor: "#36013c", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                      onClick={() => handlelayChange(1)}
                                    >+</button>
                                  </div>
                                </div>
                                <div style={{ flex: 1 }}>
                                  <div style={{ textAlign: "center", marginBottom: "5px" }}>Stake</div>
                                  <div style={{ display: "flex", height: "40px" }}>
                                    <button
                                      style={{ backgroundColor: "#36013c", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                      onClick={() => handleChange(0)}
                                    >−</button>
                                    <input
                                      type="text"
                                      value={money}
                                      onChange={(e) => setMoney(e.target.value)}
                                      style={{ backgroundColor: "#36013c", color: "white", border: "none", flex: 1, textAlign: "center", fontSize: "18px", width: "10px" }}
                                    />
                                    <button
                                      style={{ backgroundColor: "#36013c", color: "white", width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                      onClick={() => handleChange(1)}
                                    >+</button>
                                  </div>
                                </div>
                              </div>

                              <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                                <button
                                  style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(100)}
                                >+ 100</button>
                                <button
                                  style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(200)}
                                >+ 200</button>
                                <button
                                  style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(500)}
                                >+ 500</button>
                                <button
                                  style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(1000)}
                                >+ 1k</button>
                              </div>

                              <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                                <button
                                  style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(5000)}
                                >+ 5k</button>
                                <button
                                  style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(10000)}
                                >+ 10k</button>
                                <button
                                  style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(25000)}
                                >+ 25k</button>
                                <button
                                  style={{ backgroundColor: "#36013c", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                  onClick={() => setMoney(50000)}
                                >+ 50k</button>
                              </div>

                              <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                                <button style={{ backgroundColor: "#166534", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Min</button>
                                <button style={{ backgroundColor: "#1e3a8a", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Max</button>
                                <button style={{ backgroundColor: "#7e22ce", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Edit Stake</button>
                                <button
                                  style={{ backgroundColor: "#991b1b", color: "white", padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                  onClick={() => {
                                    setMoney(0);
                                    setPr(0);
                                  }}
                                >Clear</button>
                              </div>

                              <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px" }}>
                                <button
                                  style={{ backgroundColor: "#ef4444", color: "white", padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                  onClick={() => {
                                    setlayActive(0);
                                    setMoney(0);
                                    setPr(0);
                                  }}
                                >Cancel</button>
                                <button
                                  style={{ backgroundColor: "#22c55e", color: "white", padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                  onClick={() => handleSubmit()}
                                >Submit</button>
                              </div>
                            </div>
                          )}
                        </div>
                      </>
                    );
                  })
                ) : (
                   <div className="nomatch">No Matches Found.</div>
                ))}


              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};


const Tomorrow = ({ data }) => {
  const navigate = useNavigate();
  const [cricket, setCricket] = useState([]);
  const [avail, setAvail] = useState();

  const [lockedMatch, setLockedMatch] = useState([]);
  const [lockedMatchesLoaded, setLockedMatchesLoaded] = useState(false); // NEW

  const [loading, setLoading] = useState(true);
  const { themeColors } = useTheme();

  const matchDatabaseData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(base_url + '/api/webapi/matchDatabaseData', {
        headers: { "Content-Type": "application/json" },
      });
      setLockedMatch(response.data.data);
      setLockedMatchesLoaded(true); // Set as loaded
    } catch (error) {
      console.error("API Error:", error);
    } finally {

    }
  }

  console.log("locked match", lockedMatch)

  let allData = [];

  const isTomorrow = (eventDate) => {
    const now = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(now.getDate() + 1); // Get tomorrow's date

    const tomorrowFormatted = formatDate(tomorrow);
    const eventFormatted = formatDate(eventDate);

    // console.log("Tomorrow's Date:", tomorrowFormatted);
    // console.log("Event Date:", eventFormatted);

    return tomorrowFormatted === eventFormatted; // Compare only dates
  };


  const matchData = async () => {
    console.log("match data is called before")
    try {
      const response = await axios.get(
        base_url + '/api/webapi/matchapi',
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // console.log("match data is called")
      // console.log("API Response:", response?.data.result);
      const data = response?.data.result;

      // Step 1: Get array of locked event IDs
      const lockedEventIds = lockedMatch.map(match => match.eventid);


      data?.map((dta) => {
        const openDate = dta?.event.openDate;
        const eventId = dta?.event?.id;
        // console.log('openDate',openDate);

        const isLocked = lockedEventIds.includes(eventId);
        // console.log("is locked ", eventId,  isLocked);


        // console.log(dta);
        if (!isLocked && isTomorrow(openDate)) {
          allData.push(dta);
        }
      })

      setCricket(allData);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const footballData = async () => {
    console.log("football data is called before");

    try {
      const response = await axios.get(
        base_url + '/api/webapi/footballapi',
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("football data is called");

      const data = response?.data.result;

      const lockedEventIds = lockedMatch.map(match => match.eventid);
      const allData = [];

      data?.forEach((dta) => {
        const openDate = dta?.event?.openDate;
        const eventId = dta?.event?.id;

        const isLocked = lockedEventIds.includes(eventId);

        if (!isLocked && isTomorrow(openDate)) {
          allData.push(dta);
        }
      });

      setCricket(allData);
    } catch (error) {
      console.error("API Error:", error);
    }
  };


  const tennisData = async () => {
    console.log("tennis data is called before");

    try {
      const response = await axios.get(
        base_url + '/api/webapi/tennisapi',
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("tennis data is called");

      const data = response?.data.result;

      const lockedEventIds = lockedMatch.map(match => match.eventid);
      const allData = [];

      data?.forEach((dta) => {
        const openDate = dta?.event?.openDate;
        const eventId = dta?.event?.id;

        const isLocked = lockedEventIds.includes(eventId);

        if (!isLocked && isTomorrow(openDate)) {
          allData.push(dta);
        }
      });

      setCricket(allData);
    } catch (error) {
      console.error("API Error:", error);
    }
  };


  // Fetch cricket/football/tennis when `data` changes
  // 1. Fetch matchData only on mount or when `data` changes
  useEffect(() => {
    matchDatabaseData(); // Runs once on mount
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (!lockedMatchesLoaded) return; // Wait until locked matches are loaded

      if (data === 0) {
        await matchData();
      } else if (data === 1) {
        await footballData();
      } else if (data === 2) {
        await tennisData();
      }
    };

    fetchData();
  }, [data, lockedMatchesLoaded]); // Only when 'data' changes

  // 2. When cricket is updated, then call odds API
  useEffect(() => {
    const oddsData = async () => {
      if (cricket.length === 0) return;

      try {
        const marketid = cricket.map(item => item.marketId);

        const response = await axios.post(
          `${base_url}/api/webapi/market/wholeMarket`,
          marketid,
          {
            headers: {
              "Content-Type": "application/json",
            },
            timeout: 10000,
          }
        );

        const result = JSON.parse(response.data); // Remove JSON.parse if response is already JSON
        setAvail(result);
      } catch (err) {
        console.error("Error fetching odds data:", err);
      }
    };

    oddsData();
  }, [cricket]); // This effect ONLY runs when `cricket` changes




  return (
    <>
      <div _ngcontent-jrx-c94="" className="wrap-conatiner">
        <div _ngcontent-jrx-c94="">
          <div
            _ngcontent-jrx-c94=""
            className="section tabs_boxes_section no-pad-bot no-pad-top"
          >
            <div _ngcontent-jrx-c94="" className="">
              <div _ngcontent-jrx-c94="" >
                {cricket?.length > 0 ? (
                  cricket.filter(
                    (item) => avail && avail[item.marketId] && avail[item.marketId].length > 0 &&
                      avail[item.marketId].some(
                        (market) => market?.ex?.availableToBack?.length > 0 || market?.ex?.availableToLay?.length > 0
                      )
                  ).map((item, index) => {
                    const marketData = avail[item.marketId] || [];
                    // console.log('arr',marketData);

                    return (
                      <div
                        key={index}
                        _ngcontent-jrx-c94=""
                        id={item?.competition?.id}
                        className="flex-md-row justify-content-between  rounded ng-star-inserted"
                        style={{ position: "relative" }}
                      >
                        <div>
                          <div>
                            <span className="text-yellow fszz">{/*new Date(item?.event.openDate).toISOString().split("T")[0]*/}Tomorrow</span>    <span className="text-yellow fszz">{new Date(item?.event.openDate).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false })}</span>

                          </div>
                          {/* <p>{item.marketId}</p> */}
                          <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                          >
                            <div
                              _ngcontent-jrx-c94=""
                              className="section_details_box upcoming-data"
                            >
                              {item.isStarted && (
                                <span
                                  _ngcontent-jrx-c94=""
                                  className="innerHTMLScore upcoming-score ng-star-inserted"
                                >
                                  <div className="cricket-info">
                                    <div className="score"
                                    >
                                      <span>
                                        {item.title1}
                                        <span className="vOver">(45.0)</span>
                                      </span>
                                      <span className="vRun">
                                        0 - 0 - 0 - 0 - 1 - 0 -{" "}
                                      </span>
                                      <span>
                                        {item.title2}
                                        <span className="vOver">(0.0)</span>
                                      </span>
                                    </div>
                                  </div>
                                </span>
                              )}

                              <div
                                _ngcontent-jrx-c94=""
                                className="sport-type-detail"
                              >
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="runnners-odds-details"
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="sport-name-wrapper"
                                  >
                                    <div
                                      style={{ color: '#186787' }} _ngcontent-jrx-c94=""
                                      className="details_box_team"
                                    >
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="details_box_t_name t_left fs-4"
                                        onClick={() => navigate('/cricketBet',
                                          sessionStorage.setItem('marketId', item.marketId),
                                          sessionStorage.setItem('competetionid', item.competition.id),
                                          sessionStorage.setItem('eventid', item.event.id),
                                          sessionStorage.setItem('time', item?.event.openDate),
                                          sessionStorage.setItem('competitionname', item?.competition.name),
                                          sessionStorage.setItem('eventname', item?.event.name),
                                          sessionStorage.setItem('selectionid1', item?.runners[0].selectionId),
                                          sessionStorage.setItem('selectionid2', item?.runners[1].selectionId),

                                          sessionStorage.setItem('runner1', item.runners[0].runnerName),
                                          sessionStorage.setItem('runner2', item.runners[1].runnerName),
                                          { state: { marketId: item.marketId, runner1: item.runners[0].runnerName, runner2: item.runners[1].runnerName } })}
                                      >
                                        {" "}
                                        {item.runners[0].runnerName}{" "}
                                        <span
                                          _ngcontent-jrx-c94=""
                                          className="vs ng-star-inserted"
                                        >
                                          {" "}
                                          vs{" "}
                                        </span>
                                        {item.runners[1].runnerName}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="d-flex p-1 ">
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="middle-detail"
                                    >
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className={`${item.isStarted
                                          ? "green-circle inplay-blinker ng-star-inserted"
                                          : ""
                                          }`}
                                      ></div>
                                      <img
                                        _ngcontent-jrx-c94=""
                                        className="small-grid ng-star-inserted"
                                        style={{ height: "18px", width: "18px" }}
                                        src="/assets/paneal_images/tv (1).png"
                                        alt="TVKheloyaar360"
                                      />

                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="small-grid"
                                      >
                                        <span _ngcontent-jrx-c94="">
                                          <img className="imgfluid" src="/assets/images/bm-icon1.svg" />
                                        </span>
                                        <span _ngcontent-jrx-c94="">
                                          <img className="imgfluid ms-1" src="assets/images/fancy-icon1.svg" />
                                        </span>
                                      </div>
                                      {/* <div
                                    _ngcontent-jrx-c94=""
                                    className="small-grid d-md-block d-none"
                                  >
                                    <span _ngcontent-jrx-c94=""> BF</span>
                                  </div> */}
                                    </div>
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="details_odds_boxes_inn details_small_box_wrapper p-1"
                                      style={{ position: "relative", }}
                                    >
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="details_small_boxes"
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="details_small_boxes_let"
                                        >
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="details_small_boxes_inn ng-star-inserted"
                                          >

                                            {marketData && marketData.length > 0 && (
                                              <div className="d-flex runnners-odds-details gap-1">
                                                {(() => {
                                                  let backDivs = marketData.flatMap(market =>
                                                    market?.ex?.availableToBack?.length > 0
                                                      ? [{ price: market.ex.availableToBack[0].price, type: "back" }]
                                                      : []
                                                  );
                                                  let layDivs = marketData.flatMap(market =>
                                                    market?.ex?.availableToLay?.length > 0
                                                      ? [{ price: market.ex.availableToLay[0].price, type: "lay" }]
                                                      : []
                                                  );

                                                  // Fill up with empty divs if needed to ensure 6 elements
                                                  while (backDivs.length < 2) backDivs.push({ price: null, type: "back" });
                                                  while (layDivs.length < 2) layDivs.push({ price: null, type: "lay" });

                                                  let combinedDivs = [
                                                    backDivs[0],
                                                    layDivs[0],
                                                    { price: null, type: "back" }, // Empty Back
                                                    { price: null, type: "lay" }, // Empty Lay
                                                    backDivs[1],
                                                    layDivs[1],
                                                  ];

                                                  return combinedDivs.map((item, index) => (
                                                    <app-oddsbutton key={index}>
                                                      <div
                                                        id={index}
                                                        className={`d-md-flex ${item.type === "lay" ? "bg-pink" : ""
                                                          } d-none d-sm-none details_small_blue_box odds-box p-0`}
                                                      >
                                                        <span className="ng-star-inserted">
                                                          {item.price !== null ? item.price : "--"}
                                                        </span>
                                                      </div>
                                                    </app-oddsbutton>
                                                  ));
                                                })()}
                                              </div>
                                            )}

                                            {/* <div className="d-md-flex d-none d-sm-none details_small_blue_box odds-box ">
                                            <span
                                              appratehighlight=""
                                              className="ng-star-inserted"
                                            >
                                              1.05
                                            </span>
                                          </div> */}

                                            {/* <app-oddsbutton _ngcontent-jrx-c94="">
                                          <div className="d-md-flex d-none d-sm-none details_small_pink_box odds-box ">
                                            <span
                                              appratehighlight=""
                                              className="ng-star-inserted"
                                            >
                                              1.06
                                            </span>
                                          </div>
                                        </app-oddsbutton>{" "}

                                        <app-oddsbutton _ngcontent-jrx-c94="">
                                          <div className="d-md-flex d-none d-sm-none details_small_blue_box lesser_odds_opacity odds-box ">
                                            <span
                                              appratehighlight=""
                                              className="ng-star-inserted"
                                            ></span>
                                          </div>
                                          <div className="box_without_size d-flex d-md-none d-sm-flex details_small_blue_box lesser_odds_opacity small_box_col ng-star-inserted">
                                            <span appratehighlight=""> </span>
                                          </div>
                                        </app-oddsbutton>
                                        <app-oddsbutton _ngcontent-jrx-c94="">
                                          <div className="d-md-flex d-none d-sm-none details_small_pink_box lesser_odds_opacity odds-box ">
                                            <span
                                              appratehighlight=""
                                              className="ng-star-inserted"
                                            ></span>
                                          </div>
                                          <div className="box_without_size d-flex d-md-none d-sm-flex details_small_pink_box lesser_odds_opacity small_box_col ng-star-inserted">
                                            <span appratehighlight=""> </span>
                                          </div>
                                        </app-oddsbutton>{" "}

                                        <app-oddsbutton _ngcontent-jrx-c94="">
                                          <div className="d-md-flex d-none d-sm-none details_small_blue_box odds-box ">
                                            <span
                                              appratehighlight=""
                                              className="ng-star-inserted"
                                            >
                                              19.5
                                            </span>
                                          </div>
                                        </app-oddsbutton>
                                        <app-oddsbutton _ngcontent-jrx-c94="">
                                          <div className="d-md-flex d-none d-sm-none details_small_pink_box odds-box ">
                                            <span
                                              appratehighlight=""
                                              className="ng-star-inserted"
                                            >
                                              20
                                            </span>
                                          </div>
                                        </app-oddsbutton> */}
                                          </div>
                                        </div>
                                        <div
                                          _ngcontent-jrx-c94=""
                                          style={{ clear: "both" }}
                                        ></div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                   <div className="nomatch">No Matches Found.</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};


const Upcoming = ({ data }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [cricket, setCricket] = useState([]);
  const [avail, setAvail] = useState([]);
  const [lockedMatch, setLockedMatch] = useState([]);
  const [lockedMatchesLoaded, setLockedMatchesLoaded] = useState(false); // NEW
  const { themeColors } = useTheme();



  const matchDatabaseData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(base_url + '/api/webapi/matchDatabaseData', {
        headers: { "Content-Type": "application/json" },
      });
      setLockedMatch(response.data.data);
      setLockedMatchesLoaded(true); // Set as loaded
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  }
  console.log("locked match", lockedMatch)
  let allData = [];

  const isAfterTomorrow = (eventDate) => {
    const now = new Date();
    const afterTomorrow = new Date();
    afterTomorrow.setDate(now.getDate() + 2); // Get the day after tomorrow

    const eventFormatted = formatDate(eventDate);
    const afterTomorrowFormatted = formatDate(afterTomorrow);
    // console.log('afterr',afterTomorrowFormatted);

    return eventFormatted >= afterTomorrowFormatted; // Checks if event is after tomorrow
  };

  const matchData = async () => {
    console.log("upcoming match data called before ");
    try {
      const response = await axios.get(
        base_url + '/api/webapi/matchapi',
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("match data is called before ");
      const data = response?.data.result;

      const lockedEventIds = lockedMatch.map(match => match.eventid);
      const allData = [];

      data?.forEach((dta) => {
        const openDate = dta?.event?.openDate;
        const eventId = dta?.event?.id;

        const isLocked = lockedEventIds.includes(eventId);

        if (!isLocked && isAfterTomorrow(openDate)) {
          allData.push(dta);
        }
      });

      setCricket(allData);
    } catch (error) {
      console.error("API Error:", error);
    }
  };


  const footballData = async () => {
    console.log("football upcoming called before ");
    try {
      const response = await axios.get(
        base_url + '/api/webapi/footballapi',
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("football after upcoming");
      const data = response?.data.result;

      const lockedEventIds = lockedMatch.map(match => match.eventid);
      const allData = [];

      data?.forEach((dta) => {
        const openDate = dta?.event?.openDate;
        const eventId = dta?.event?.id;

        const isLocked = lockedEventIds.includes(eventId);

        if (!isLocked && isAfterTomorrow(openDate)) {
          allData.push(dta);
        }
      });

      setCricket(allData);
    } catch (error) {
      console.error("API Error:", error);
    }
  };


  const tennisData = async () => {
    try {
      const response = await axios.get(
        base_url + '/api/webapi/tennisapi',
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("tennis after upcoming");
      const data = response?.data.result;

      const lockedEventIds = lockedMatch.map(match => match.eventid);
      const allData = [];

      data?.forEach((dta) => {
        const openDate = dta?.event?.openDate;
        const eventId = dta?.event?.id;

        const isLocked = lockedEventIds.includes(eventId);

        if (!isLocked && isAfterTomorrow(openDate)) {
          allData.push(dta);
        }
      });

      setCricket(allData);
    } catch (error) {
      console.error("API Error:", error);
    }
  };



  useEffect(() => {
    matchDatabaseData(); // Runs once on mount
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (!lockedMatchesLoaded) return; // Wait until locked matches are loaded

      if (data === 0) {
        await matchData();
      } else if (data === 1) {
        await footballData();
      } else if (data === 2) {
        await tennisData();
      }
    };

    fetchData();
  }, [data, lockedMatchesLoaded]);

  // 2. When cricket is updated, then call odds API
  useEffect(() => {
    const oddsData = async () => {
      if (cricket.length === 0) return;

      try {
        const marketid = cricket.map(item => item.marketId);

        const response = await axios.post(
          `${base_url}/api/webapi/market/wholeMarket`,
          marketid,
          {
            headers: {
              "Content-Type": "application/json",
            },
            timeout: 10000,
          }
        );

        const result = JSON.parse(response.data); // Remove JSON.parse if response is already JSON
        setAvail(result);
      } catch (err) {
        console.error("Error fetching odds data:", err);
      }
    };

    oddsData();
  }, [cricket]); // This effect ONLY runs when `cricket` changes

  // console.log(cricket);

  return (
    <>
      <div _ngcontent-jrx-c94="" className="wrap-conatiner">
        <div _ngcontent-jrx-c94="">
          <div
            _ngcontent-jrx-c94=""
            className="section tabs_boxes_section no-pad-bot no-pad-top"
          >
            <div _ngcontent-jrx-c94="" className="">
              <div _ngcontent-jrx-c94="" className="sports-wrapper">
                {cricket?.length > 0 ? (
                  cricket.filter(
                    (item) => avail && avail[item.marketId] && avail[item.marketId].length > 0 &&
                      avail[item.marketId].some(
                        (market) => market?.ex?.availableToBack?.length > 0 || market?.ex?.availableToLay?.length > 0
                      )
                  ).map((item, index) => {
                    const marketData = avail[item.marketId] || [];
                    // console.log('arr',marketData);

                    return (
                      <>
                        <div
                          key={index}
                          _ngcontent-jrx-c94=""
                          id={item?.competition?.id}
                          className="flex-md-row justify-content-between  rounded ng-star-inserted"
                          style={{ position: "relative" }}
                        >
                          <span className="text-yellow fszz">{new Date(item?.event.openDate).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false })}</span> <span className="text-yellow fszz">{new Date(item?.event.openDate).toISOString().split("T")[0]}</span>
                          {/* <p>{item.marketId}</p> */}
                          <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                          >
                            <div
                              _ngcontent-jrx-c94=""
                              className="section_details_box upcoming-data"
                            >
                              {item.isStarted && (
                                <span
                                  _ngcontent-jrx-c94=""
                                  className="innerHTMLScore upcoming-score ng-star-inserted"
                                >
                                  <div className="cricket-info">
                                    <div className="score"
                                    >
                                      <span>
                                        {item.title1}
                                        <span className="vOver">(45.0)</span>
                                      </span>
                                      <span className="vRun">
                                        0 - 0 - 0 - 0 - 1 - 0 -{" "}
                                      </span>
                                      <span>
                                        {item.title2}
                                        <span className="vOver">(0.0)</span>
                                      </span>
                                    </div>
                                  </div>
                                </span>
                              )}

                              <div
                                _ngcontent-jrx-c94=""
                                className="sport-type-detail"
                              >
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="runnners-odds-details"
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="sport-name-wrapper"
                                  >
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="details_box_team"
                                    >
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="details_box_t_name t_left fs-4"
                                        onClick={() => navigate('/cricketBet',
                                          sessionStorage.setItem('marketId', item.marketId),
                                          sessionStorage.setItem('competetionid', item.competition.id),
                                          sessionStorage.setItem('eventid', item.event.id),
                                          sessionStorage.setItem('time', item?.event.openDate),
                                          sessionStorage.setItem('competitionname', item?.competition.name),
                                          sessionStorage.setItem('eventname', item?.event.name),
                                          sessionStorage.setItem('selectionid1', item?.runners[0].selectionId),
                                          sessionStorage.setItem('selectionid2', item?.runners[1].selectionId),

                                          sessionStorage.setItem('runner1', item.runners[0].runnerName),
                                          sessionStorage.setItem('runner2', item.runners[1].runnerName),
                                          { state: { marketId: item.marketId, runner1: item.runners[0].runnerName, runner2: item.runners[1].runnerName } })}
                                      >
                                        {" "}
                                        {item?.event?.name}{" "}
                                        {/* <span
                                        _ngcontent-jrx-c94=""
                                        className="vs ng-star-inserted"
                                      >
                                        {" "}
                                        vs{" "}
                                      </span>
                                      {item.runners[1].runnerName} */}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="d-flex  p-1">
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="middle-detail"
                                    >
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className={`${item.isStarted
                                          ? "green-circle inplay-blinker ng-star-inserted"
                                          : ""
                                          }`}
                                      ></div>
                                      <img
                                        _ngcontent-jrx-c94=""
                                        className="small-grid ng-star-inserted"
                                        style={{ height: "18px", width: "18px" }}
                                        src="/assets/paneal_images/tv (1).png"
                                        alt="TVKheloyaar360"
                                      />

                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="small-grid"
                                      >
                                        <span _ngcontent-jrx-c94="">
                                          <img className="imgfluid" src="/assets/images/bm-icon1.svg" />
                                        </span>
                                        <span _ngcontent-jrx-c94="">
                                          <img className="imgfluid ms-1" src="assets/images/fancy-icon1.svg" />
                                        </span>
                                      </div>
                                      {/* <div
                                    _ngcontent-jrx-c94=""
                                    className="small-grid d-md-block d-none"
                                  >
                                    <span _ngcontent-jrx-c94=""> BF</span>
                                  </div> */}
                                    </div>
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="details_odds_boxes_inn details_small_box_wrapper p-1"
                                      style={{ position: "relative", }}
                                    >
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="details_small_boxes"
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="details_small_boxes_let"
                                        >
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="details_small_boxes_inn ng-star-inserted"
                                          >

                                            {marketData && marketData.length > 0 && (
                                              <div className="d-flex runnners-odds-details gap-1">
                                                {(() => {
                                                  let backDivs = marketData.flatMap(market =>
                                                    market?.ex?.availableToBack?.length > 0
                                                      ? [{ price: market.ex.availableToBack[0].price, type: "back" }]
                                                      : []
                                                  );
                                                  let layDivs = marketData.flatMap(market =>
                                                    market?.ex?.availableToLay?.length > 0
                                                      ? [{ price: market.ex.availableToLay[0].price, type: "lay" }]
                                                      : []
                                                  );

                                                  // Fill up with empty divs if needed to ensure 6 elements
                                                  while (backDivs.length < 2) backDivs.push({ price: null, type: "back" });
                                                  while (layDivs.length < 2) layDivs.push({ price: null, type: "lay" });

                                                  let combinedDivs = [
                                                    backDivs[0],
                                                    layDivs[0],
                                                    { price: null, type: "back" }, // Empty Back
                                                    { price: null, type: "lay" }, // Empty Lay
                                                    backDivs[1],
                                                    layDivs[1],
                                                  ];

                                                  return combinedDivs.map((item, index) => (
                                                    <app-oddsbutton key={index}>
                                                      <div
                                                        id={index}
                                                        className={`d-md-flex ${item.type === "lay" ? "bg-pink" : ""
                                                          } d-none d-sm-none details_small_blue_box odds-box p-0`}
                                                      >
                                                        <span className="ng-star-inserted">
                                                          {item.price !== null ? item.price : "--"}
                                                        </span>
                                                      </div>
                                                    </app-oddsbutton>
                                                  ));
                                                })()}
                                              </div>
                                            )}

                                            {/* <div className="d-md-flex d-none d-sm-none details_small_blue_box odds-box ">
                                            <span
                                              appratehighlight=""
                                              className="ng-star-inserted"
                                            >
                                              1.05
                                            </span>
                                          </div> */}

                                            {/* <app-oddsbutton _ngcontent-jrx-c94="">
                                          <div className="d-md-flex d-none d-sm-none details_small_pink_box odds-box ">
                                            <span
                                              appratehighlight=""
                                              className="ng-star-inserted"
                                            >
                                              1.06
                                            </span>
                                          </div>
                                        </app-oddsbutton>{" "}

                                        <app-oddsbutton _ngcontent-jrx-c94="">
                                          <div className="d-md-flex d-none d-sm-none details_small_blue_box lesser_odds_opacity odds-box ">
                                            <span
                                              appratehighlight=""
                                              className="ng-star-inserted"
                                            ></span>
                                          </div>
                                          <div className="box_without_size d-flex d-md-none d-sm-flex details_small_blue_box lesser_odds_opacity small_box_col ng-star-inserted">
                                            <span appratehighlight=""> </span>
                                          </div>
                                        </app-oddsbutton>
                                        <app-oddsbutton _ngcontent-jrx-c94="">
                                          <div className="d-md-flex d-none d-sm-none details_small_pink_box lesser_odds_opacity odds-box ">
                                            <span
                                              appratehighlight=""
                                              className="ng-star-inserted"
                                            ></span>
                                          </div>
                                          <div className="box_without_size d-flex d-md-none d-sm-flex details_small_pink_box lesser_odds_opacity small_box_col ng-star-inserted">
                                            <span appratehighlight=""> </span>
                                          </div>
                                        </app-oddsbutton>{" "}

                                        <app-oddsbutton _ngcontent-jrx-c94="">
                                          <div className="d-md-flex d-none d-sm-none details_small_blue_box odds-box ">
                                            <span
                                              appratehighlight=""
                                              className="ng-star-inserted"
                                            >
                                              19.5
                                            </span>
                                          </div>
                                        </app-oddsbutton>
                                        <app-oddsbutton _ngcontent-jrx-c94="">
                                          <div className="d-md-flex d-none d-sm-none details_small_pink_box odds-box ">
                                            <span
                                              appratehighlight=""
                                              className="ng-star-inserted"
                                            >
                                              20
                                            </span>
                                          </div>
                                        </app-oddsbutton> */}
                                          </div>
                                        </div>
                                        <div
                                          _ngcontent-jrx-c94=""
                                          style={{ clear: "both" }}
                                        ></div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  })
                ) : (
                   <div className="nomatch">No Matches Found.</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};



export const FrontPage = () => {
  const { themeColors } = useTheme();
  const [isSidebar, setSidebar] = useState(false);
  const [isInplay, setInplay] = useState(true);
  const [isTomorrow, setTomorrow] = useState(false);
  const [isUpcoming, setUpcoming] = useState(false);
  const [isActive, setActiveLink] = useState(0);
  const [jiliGames, setJiliGames] = useState([]);
  const [token, setToken] = useState();
  const [casino, setCasino] = useState([]);
  const [ent, setEnt] = useState([]);
  const [endorphina, setEndorphina] = useState([]);
  // const [latest, setLatest]= useState([]);
  const [evolution, setEvolution] = useState([]);
  const [games, setGames] = useState([]);
  const { isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();

  const handlePlay = (id) => {
    setInplay(false);
    setTomorrow(false);
    setUpcoming(false);

    if (id === "inplay") {
      setInplay(true);

    } else if (id === "tomorrow") {
      setTomorrow(true);

    } else {
      setUpcoming(true);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleResize = () => {
      if (window.innerWidth > 991) {
        setSidebar(true);
      } else {
        setSidebar(false);
      }
    };

    const casinogames = async () => {
      try {
        const eventSource = new EventSource(base_url + '/api/valid/token', {
          withCredentials: true
        });

        let receivedGames = [];

        // Provider groupings
        const allowedProviders = [
          'Playtech Live', 'Playtech Casino', 'Skywind Casino', 'RTG Slots',
          '7Mojos Casino', 'ICONIC21', 'Habanero'
        ];
        const voltProvide = ['Red Tiger Gaming', 'Betgames', 'Netgame', 'OnlyPlay', 'CQ9 Casino', 'Live88'];
        const endorphina = ['Qora', 'Ezugi', 'Gamizx', 'Triple PG', 'Evoplay'];
        const latst = ['ICONIC21', 'Live88', 'Spribe', 'Aviatrix'];
        const evoluton = ['Evolution Gaming'];

        const classifyAndSetBuckets = (gamesList) => {
          const jili = [], casino = [], ent = [], endor = [], latest = [], evolution = [];

          gamesList.forEach((game) => {
            const providerName = game?.provider?.name;
            if (!providerName) return;


            if (providerName === 'Jili') jili.push(game);
            if (allowedProviders.includes(providerName)) casino.push(game);
            if (voltProvide.includes(providerName)) ent.push(game);
            if (endorphina.includes(providerName)) endor.push(game);
            if (latst.includes(providerName)) latest.push(game);
            if (evoluton.includes(providerName)) evolution.push(game);
          });

          // Update UI buckets
          setJiliGames(jili);
          setCasino(casino);
          setEnt(ent);
          setEndorphina(endor);
          // setLatest(latest);
          setEvolution(evolution);

        };



        eventSource.addEventListener('message', (event) => {
          const data = JSON.parse(event.data);

          // Save token
          if (data.token) {
            setToken(data.token);
            localStorage.setItem('game_token', data.token);
          }

          // New chunk arrives
          if (data.chunk && Array.isArray(data.chunk)) {
            receivedGames = [...receivedGames, ...data.chunk];

            setGames([...receivedGames]); // All games for general view
            classifyAndSetBuckets(receivedGames); // Filter buckets updated live
          }

          // All chunks done
          if (data.complete) {
            eventSource.close();
            // Final classification (already done in chunk processing)
          }

          if (data.error) {
            // console.error("Backend error:", data.error);
            eventSource.close();
          }
        });

        eventSource.onerror = (error) => {
          // console.error("Connection error:", error);
          eventSource.close();
        };

      } catch (err) {
        console.error('Error initializing game stream:', err);
      }
    };



    casinogames();
    handleResize();
  }, []);

  const handleActiveLink = (index) => {

    setActiveLink(index);

  };

  const scrollableList = [
    { name: "Cricket", imgLink: "/assets/images/cricket.svg" },
    // { name: "Football", imgLink: "/assets/images/football.webp" },
    // { name: "Tennis", imgLink: "/assets/images/Tennis New.svg" },
    // { name: "Horce Racing", imgLink: "/assets/images/Basketbaalls.svg" },
    // { name: "GreyHound Racing", imgLink: "/assets/images/baseball-svgrepo-com 1.svg" },
  ];

  const scrollableList2 = [
    { name: "Football", imgLink: "/assets/images/football.webp" },
  ];
  const scrollableList3 = [
    { name: "Tennis", imgLink: "/assets/images/Tennis New.svg" },
  ];
  const scrollableList4 = [
    { name: "Horce Racing", imgLink: "/assets/images/Basketbaalls.svg" },
  ];
  const scrollableList5 = [
    { name: "GreyHound Racing", imgLink: "/assets/images/baseball-svgrepo-com 1.svg" },
  ];



  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 991);
  const isSmallScreen = window.innerWidth <= 768;

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 991);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const images = [
    "/assets/images/banner7.webp",
    "/assets/images/banner8.webp",
    "/assets/images/banner9.webp",
    "/assets/images/banner10.webp",
    "/assets/images/banner11.webp",
    "/assets/images/banner12.webp",
    "/assets/images/banner13.webp",
    "/assets/images/banner14.webp",
    "/assets/images/banner15.webp",
    "/assets/images/banner9.webp",
  ];

  const images2 = [
    "assets/images/banner2.webp",
    "assets/images/banner3.webp",
    "assets/images/banner4.webp",
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: isSmallScreen ? 4 : 9, // Show 5 at a time (like your image)
    slidesToScroll: 1, // Scroll 1 at a time
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: true,
  };

  const settings2 = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2, // Show 5 at a time (like your image)
    slidesToScroll: 1, // Scroll 1 at a time
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: true,
  };

  // const styles = {
  //   marqueeDiv: {
  //     background: 'linear-gradient(rgb(103, 205, 246) 0%, rgb(51, 147, 186) 50%, rgb(0, 66, 92) 100%)',
  //     zIndex: 99,
  //     position: 'fixed',
  //     bottom: 0,
  //     width: '101%',
  //   }
  // };


  useEffect(() => {
    if (isAuthenticated) {
      navigate("/home", { replace: true })
    }
  }, [isAuthenticated]);


  return (
    <app-root _nghost-jrx-c101="" ng-version="12.2.16" >

      <div _ngcontent-jrx-c101="">
        <app-toasts
          _ngcontent-jrx-c101=""
          aria-live="polite"
          aria-atomic="true"
          className="ngb-toasts"
        ></app-toasts>
        <router-outlet _ngcontent-jrx-c101=""></router-outlet>
        <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
          <div _ngcontent-jrx-c95="" className="head-container">
            {/* {!isMobile && <TopBar />}
            {isMobile && <Header isSidebar2={isSidebar2} setSidebar={setSidebar} />} */}
            {/* {isLargeScreen && <TopBar />} */}

            {/* <div>
              <div className="row" style={styles.marqueeDiv}>
                <marquee>
                  <p className="mb-2" style={{ fontSize: "13px" }}>
                    1️⃣ Welcome To Our Exchange...... 💫💫💫
                  </p>
                </marquee>
              </div>
            </div> */}

            <Header isSidebar={isSidebar} setSidebar={setSidebar} />
            <div _ngcontent-jrx-c95="" className="body-container">
              {isSmallScreen && <Sidebar isSidebar={isSidebar} setSidebar={setSidebar} />}
              <div
                _ngcontent-jrx-c95=""
                className={`rightbar`}
                style={{
                  paddingLeft: isLargeScreen ? "0px" : '0px',
                  paddingRight: isLargeScreen ? "3px" : '0px',
                  width: "100%",
                  transition: "width 0.3s ease-in-out",
                }}
              >


                {/* <Header isSidebar={isSidebar} setSidebar={setSidebar} /> */}
                {/* <div className="news-bar">
      <marquee style={{ width: '100%' }}>
        <p className="m-0 w-100">
          👉IPL MONTH DHAMAKA OFFER..GET 3% REFILL BONUS ON EVERY DEPOSIT... USDT DEPOSIT OPTION IS ALSO AVAILABLE ON OUR SITE👈👈...TO CONFIRM DEPOSIT BRANCH NUMBER CONTACT HELPDESK NO +265899881378
        </p>
      </marquee>
    </div> */}
                <div
                  _ngcontent-jrx-c95=""
                  className="sports-casino mt-15 d-none"
                >
                  <ul _ngcontent-jrx-c95="" className="popular-tab">
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/sports/sportsbyid/4"
                      style={{
                        background:
                          "linear-gradient(270deg, #c435ef 0%, #662ef3 100%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Cricket
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/cricket.svg"
                        alt="Cricket_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/sports/sportsbyid/1"
                      style={{
                        background:
                          "linear-gradient(91deg, #07abd0 0.66%, #95d7e6 99.47%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Football
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/football.webp"
                        alt="Football_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/sports/sportsbyid/2"
                      style={{
                        background:
                          "linear-gradient(91deg, #f7a545 0.66%, #d8560c 99.47%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Tennis
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/tennis.webp"
                        alt="Tennis_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/sports/sportsbyid/7522"
                      style={{
                        background:
                          "linear-gradient(91deg, #ec62e2 0.66%, #9c31f0 99.47%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Basketball
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/basketball.webp"
                        alt="Basketball_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/sports/raceschedule/7/ALL"
                      style={{
                        background:
                          "linear-gradient(91deg, #07abd0 0.66%, #95d7e6 99.47%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Horse Racing
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/horse-racing.gif"
                        style={{ height: "35px" }}
                        alt="Horse-racing_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/sports/raceschedule/4339/ALL"
                      style={{
                        background:
                          "linear-gradient(270deg, #c435ef 0%, #662ef3 100%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Greyhound
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/Greyhound transparent.gif"
                        style={{ height: "35px" }}
                        alt="Greyhound_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/sports/sportsbyid/6"
                      style={{
                        background:
                          "linear-gradient(91deg, #f7a545 0.66%, #d8560c 99.47%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Boxing
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/horse-racing.gif"
                        style={{ height: "35px" }}
                        alt="Boxing_Kheloyaar360"
                      />
                    </li>
                  </ul>
                </div>
                <div _ngcontent-jrx-c95="" className="sports-casino d-none">
                  <ul _ngcontent-jrx-c95="" className="popular-tab">
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/casinos/games/LIVECASINO"
                      style={{
                        background:
                          "linear-gradient(91deg, #ec62e2 0.66%, #9c31f0 99.47%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Live Casino
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/live_casino.webp"
                        alt="Live Casino_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/casinos/games/ROULETTE"
                      style={{
                        background:
                          "linear-gradient(90deg, #20a635 2.29%, #22ff7a 83.94%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Casino Lobby
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/casino_lobby.webp"
                        alt="Casino Lobby_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      style={{
                        background:
                          "linear-gradient(91deg, #07abd0 0.66%, #95d7e6 99.47%)",
                      }}
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Crazy Time
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/crazy_time.webp"
                        alt="Crazy Time_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/casinos/games/INSTANTWIN"
                      style={{
                        background:
                          "linear-gradient(270deg, #3984f7 0%, #242156 100%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Crash Games
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/crash_games.webp"
                        alt="Crash Games_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      style={{
                        background:
                          "linear-gradient(91deg, #ec62e2 0.66%, #9c31f0 99.47%)",
                      }}
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Virtual Sports
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/virtual_sports.webp"
                        alt="Virtual Sports_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      style={{
                        background:
                          "linear-gradient(91deg, #07abd0 0.66%, #95d7e6 99.47%)",
                      }}
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Evolution
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/evolution.webp"
                        alt="Evolution_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/casinos/games/TABLEGAME"
                      style={{
                        background:
                          "linear-gradient(91deg, #ec62e2 0.66%, #9c31f0 99.47%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Table Games
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/table_games.webp"
                        alt="Table Games_Kheloyaar360"
                      />
                    </li>
                  </ul>
                </div>
                {/* <Banner /> */}

                {/* <CategoryGrid></CategoryGrid> */}

                <app-upcoming
                  _ngcontent-jrx-c95=""
                  _nghost-jrx-c94=""
                  className="ng-star-inserted"
                >
                  <div _ngcontent-jrx-c94="" className="upcoming-container">
                    <CarouselF />
                    <div>
                      {!isSmallScreen ? (
                        <div className="row px-3">
                          <div className="col-lg-4 p-1 mb-0">
                            <img src="assets/images/banner2.webp" className="img-fluid" />
                          </div>
                          <div className="col-lg-4 p-1 mb-0">
                            <img src="assets/images/banner3.webp" className="img-fluid" />
                          </div>
                          <div className="col-lg-4 p-1 mb-0">
                            <img src="assets/images/banner4.webp" className="img-fluid" />
                          </div>
                        </div>
                      ) : (
                        <Slider {...settings2}>
                          {images2.map((src, index) => (
                            <div className="mt-2" key={index}>
                              <img
                                src={src}
                                className="img-fluid"
                                alt={`slide-${index}`}
                                style={{ width: "100%", borderRadius: "10px" }}
                              />
                            </div>
                          ))}
                        </Slider>
                      )}
                      <div className="row" style={{ padding: isSmallScreen ? '0px' : '10px' }}>
                        <div className="col-lg-6 p-1 mb-1">
                          <img src="assets/images/banner19.gif" className="img-fluid" />
                        </div>
                        <div className="col-lg-6 p-1 mb-1">
                          <img src="assets/images/banner20.gif" className="img-fluid" />
                        </div>
                      </div>

                      <div className="row">
                        <h5 className="fw-bold ps-3" style={{ color: "var(--dark-theme-white-color)" }}>Top Games</h5>
                        <div style={{ width: "100%", margin: "0 auto" }}>
                          <Slider {...settings}>
                            {images.map((src, index) => (
                              <div key={index}>
                                <img
                                  src={src}
                                  className="img-fluid"
                                  alt={`slide-${index}`}
                                  style={{ width: "100%", borderRadius: "10px" }}
                                />
                              </div>
                            ))}
                          </Slider>
                        </div>
                      </div>
                    </div>
                    {/* <div  className="pt-1 pb-1"  >
                     <div _ngcontent-jrx-c94="" className="upcoming  p-1"  style={{border:"1px solid  #22222f"}}>
                      <div _ngcontent-jrx-c94="" className="items p-1">
                        <span
                          _ngcontent-jrx-c94=""
                         
                         
                        >
                       Races
                        </span>
                        
                      </div>
                      <div
                        _ngcontent-jrx-c94=""
                        routerlink="/sports"
                        className="view-all"
                        tabIndex="0"
                      >
                      
                      </div>
                    </div>
                    <div className=" upcoming pt-1 pb-1">
                      <ul className="tabs d-flex mb-0 align-items-center  gap-2  p-1">
                        <li className="race-type-img" style={{ width: "50px" }}>
                          <img
                            height="50px"
                            src="https://daba.b-cdn.net/global/horse-racing-new.gif"
                            alt="Horse racing"
                            title="Horse racing"
                          />
                        </li>

                        <li className="pointer">
                          <span className="d-flex justify-content-center align-items-center race-item">
                            <img
                              className="flag_logo AU"
                              src="https://daba.b-cdn.net/flags/AU.svg"
                              alt="AU flag"
                              title="AU"
                            />
                            <span className="sm-fs-13">AU</span>
                          </span>
                        </li>

                        <li className="pointer">
                          <span className="d-flex justify-content-center align-items-center race-item">
                            <img
                              className="flag_logo US"
                              src="https://daba.b-cdn.net/flags/US.svg"
                              alt="US flag"
                              title="US"
                            />
                            <span className="sm-fs-13">US</span>
                          </span>
                        </li>

                        <li className="pointer">
                          <span className="d-flex justify-content-center align-items-center race-item">
                            <img
                              className="flag_logo ZA"
                              src="https://daba.b-cdn.net/flags/ZA.svg"
                              alt="ZA flag"
                              title="ZA"
                            />
                            <span className="sm-fs-13">ZA</span>
                          </span>
                        </li>

                        <li className="pointer">
                          <span className="d-flex justify-content-center align-items-center race-item">
                            <img
                              className="flag_logo FR"
                              src="https://daba.b-cdn.net/flags/FR.svg"
                              alt="FR flag"
                              title="FR"
                            />
                            <span className="sm-fs-13">FR</span>
                          </span>
                        </li>

                        <li className="pointer">
                          <span className="d-flex justify-content-center align-items-center race-item">
                            <img
                              className="flag_logo IE"
                              src="https://daba.b-cdn.net/flags/IE.svg"
                              alt="IE flag"
                              title="IE"
                            />
                            <span className="sm-fs-13">IE</span>
                          </span>
                        </li>

                        <li className="pointer">
                          <span className="d-flex justify-content-center align-items-center race-item">
                            <img
                              className="flag_logo GB"
                              src="https://daba.b-cdn.net/flags/GB.svg"
                              alt="GB flag"
                              title="GB"
                            />
                            <span className="sm-fs-13">GB</span>
                          </span>
                        </li>
                      </ul>
                    </div>

                    <div className=" upcoming pt-1 pb-1 ">
                      <ul className="tabs d-flex mb-0 align-items-center  gap-2">
                        <li className="race-type-img" style={{ width: "50px" }}>
                          <img
                            height="50px"
                            src="https://daba.b-cdn.net/global/greyhound-racing.gif"
                            alt="Greyhound racing"
                            title="Greyhound racing"
                          />
                        </li>

                        <li className="pointer">
                          <span className="d-flex justify-content-center align-items-center race-item">
                            <img
                              className="flag_logo AU"
                              src="https://daba.b-cdn.net/flags/AU.svg"
                              alt="AU flag"
                              title="AU"
                            />
                            <span className="sm-fs-13">AU</span>
                          </span>
                        </li>

                        <li className="pointer">
                          <span className="d-flex justify-content-center align-items-center race-item">
                            <img
                              className="flag_logo GB"
                              src="https://daba.b-cdn.net/flags/GB.svg"
                              alt="GB flag"
                              title="GB"
                            />
                            <span className="sm-fs-13">GB</span>
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div> */}

                    {/* <div _ngcontent-jrx-c94="" className="upcoming">
                      <div _ngcontent-jrx-c94="" className="items">
                        <span
                          _ngcontent-jrx-c94=""
                          className={`inp ${isInplay ? "active-bar" : ""}`}
                          onClick={() => handlePlay("inplay")}
                        >
                          Inplay
                        </span>
                        <span
                          _ngcontent-jrx-c94=""
                          className={`inp ${isTomorrow ? "active-bar" : ""}`}
                          onClick={() => handlePlay("tomorrow")}
                        >
                          Tomorrow
                        </span>
                        <span
                          _ngcontent-jrx-c94=""
                          className={`inp ${isUpcoming ? "active-bar" : ""}`}
                          onClick={() => handlePlay("upcoming")}
                        >
                          Upcoming
                        </span>
                      </div>
                      <div
                        _ngcontent-jrx-c94=""
                        routerlink="/sports"
                        className="view-all"
                        tabIndex="0"
                      >
                        <span _ngcontent-jrx-c94=""> See All → </span>
                      </div>
                    </div> */}
                  </div>
                  <div _ngcontent-jrx-c94="" className="scrollable-list py-1 px-2 mx-1">
                    {scrollableList.map((item, index) => {
                      return (
                        <div
                          key={index}
                          _ngcontent-jrx-c94=""
                          className={`inp list-item ${isActive === index ? "active" : ""
                            } first-item ng-star-inserted`}
                          onClick={() => handleActiveLink(index)}
                        >{" "}
                          {item.name}{" "}
                        </div>
                      );
                    })}
                  </div>
                  <Inplay data={0} />
                  <div _ngcontent-jrx-c94="" className="scrollable-list py-1 px-2 mx-1">
                    {scrollableList2.map((item, index) => {
                      return (
                        <div
                          key={index}
                          _ngcontent-jrx-c94=""
                          className={`inp list-item ${isActive === index ? "active" : ""
                            } first-item ng-star-inserted`}
                          onClick={() => handleActiveLink(index)}
                        >
                          {" "}
                          {item.name}{" "}
                        </div>
                      );
                    })}
                  </div>
                  <Inplay data={1} />
                  <div _ngcontent-jrx-c94="" className="scrollable-list py-1 px-2 mx-1">
                    {scrollableList3.map((item, index) => {
                      return (
                        <div
                          key={index}
                          _ngcontent-jrx-c94=""
                          className={`inp list-item ${isActive === index ? "active" : ""
                            } first-item ng-star-inserted`}
                          onClick={() => handleActiveLink(index)}
                        >
                          {" "}
                          {item.name}{" "}
                        </div>
                      );
                    })}
                  </div>
                  <Inplay data={2} />
                  <div _ngcontent-jrx-c94="" className="scrollable-list py-1 px-2 mx-1">
                    {scrollableList4.map((item, index) => {
                      return (
                        <div
                          key={index}
                          _ngcontent-jrx-c94=""
                          className={`inp list-item ${isActive === index ? "active" : ""
                            } first-item ng-star-inserted`}
                          onClick={() => handleActiveLink(index)}
                        >
                          {" "}
                          {item.name}{" "}
                        </div>
                      );
                    })}
                  </div>
                  <Inplay data={3} />
                  <div _ngcontent-jrx-c94="" className="scrollable-list py-1 px-2 mx-1">
                    {scrollableList5.map((item, index) => {
                      return (
                        <div
                          key={index}
                          _ngcontent-jrx-c94=""
                          className={`inp list-item ${isActive === index ? "active" : ""
                            } first-item ng-star-inserted`}
                          onClick={() => handleActiveLink(index)}
                        >
                          {" "}
                          {item.name}{" "}
                        </div>
                      );
                    })}
                  </div>
                  <Inplay data={4} />
                  {/* {isTomorrow && <Tomorrow data={isActive} />}
                  {isUpcoming && <Upcoming data={isActive} />} */}
                </app-upcoming>


                {/* latest games */}
                {/* <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                  <div _ngcontent-jrx-c95="" className="popular-today-heading">
                    <div _ngcontent-jrx-c95="">
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/titleImg.svg"
                        alt="Popular Games_Kheloyaar360"
                      />
                      <span _ngcontent-jrx-c95="">Latest Games</span>
                    </div>
                    <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                      <Link
                        _ngcontent-jrx-c95=""
                        className="see-all-a"
                        href="https://kheloyaar360.net/casinos/games/POPULAR"
                      >
                        See All
                        <svg
                          _ngcontent-jrx-c95=""
                          className="svg-inline--fa fa-arrow-right fa-w-14 iconArrow"
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fas"
                          data-icon="arrow-right"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 448 512"
                          data-fa-i2svg=""
                        >
                          <path
                            fill="currentColor"
                            d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
                          ></path>
                        </svg>
                      </Link>
                    </div>
                  </div>
                  <SliderContainer CurrentSlider={{token, games:latest}}/>
                </div> */}

                {/* hot games */}
                {/* <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                  <div _ngcontent-jrx-c95="" className="popular-today-heading">
                    <div _ngcontent-jrx-c95="">
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/hots.svg"
                        alt="Popular Games_Kheloyaar360"
                      />
                      <span _ngcontent-jrx-c95="">Hot Games</span>
                    </div>
                    <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                      <Link
                        _ngcontent-jrx-c95=""
                        className="see-all-a"
                        to={'/jiliAll'}
                        href="https://kheloyaar360.net/casinos/games/POPULAR"

                      >
                        See All
                        <svg
                          _ngcontent-jrx-c95=""
                          className="svg-inline--fa fa-arrow-right fa-w-14 iconArrow"
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fas"
                          data-icon="arrow-right"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 448 512"
                          data-fa-i2svg=""
                        >
                          <path
                            fill="currentColor"
                            d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
                          ></path>
                        </svg>
                      </Link>
                    </div>
                  </div>
                  <SliderContainer CurrentSlider={{ token, games: ent }} />
                </div> */}


                {/* new release */}
                {/* <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                  <div _ngcontent-jrx-c95="" className="popular-today-heading">
                    <div _ngcontent-jrx-c95="">
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/NewReleases.png"
                        alt="Popular Games_Kheloyaar360"
                      />
                      <span _ngcontent-jrx-c95="">New Releases</span>
                    </div>
                     <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                      <Link
                        _ngcontent-jrx-c95=""
                        className="see-all-a"
                        to={'/jiliAll'}
                        href="https://kheloyaar360.net/casinos/games/POPULAR"
                        
                      >
                        See All
                        <svg
                          _ngcontent-jrx-c95=""
                          className="svg-inline--fa fa-arrow-right fa-w-14 iconArrow"
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fas"
                          data-icon="arrow-right"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 448 512"
                          data-fa-i2svg=""
                        >
                          <path
                            fill="currentColor"
                            d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
                          ></path>
                        </svg>
                      </Link>
                    </div> 
                  </div>
                  <SliderContainer CurrentSlider={{ token, games: endorphina }} />
                </div> */}


                {/* jili games */}
                {/* <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                  <div _ngcontent-jrx-c95="" className="popular-today-heading">
                    <div _ngcontent-jrx-c95="">
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/jili.svg"
                        alt="Popular Games_Kheloyaar360"
                      />
                      <span _ngcontent-jrx-c95="">Jili (Indian Casino)</span>
                    </div>
                     <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                      <Link
                        _ngcontent-jrx-c95=""
                        className="see-all-a"
                        to={'/jiliAll'}
                        href="https://kheloyaar360.net/casinos/games/POPULAR"
                        
                      >
                        See All
                        <svg
                          _ngcontent-jrx-c95=""
                          className="svg-inline--fa fa-arrow-right fa-w-14 iconArrow"
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fas"
                          data-icon="arrow-right"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 448 512"
                          data-fa-i2svg=""
                        >
                          <path
                            fill="currentColor"
                            d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
                          ></path>
                        </svg>
                      </Link>
                    </div> 
                  </div>
                  <SliderContainer CurrentSlider={{ token, games: jiliGames }} />
                </div> */}

                {/* evolution */}
                {/* <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                  <div _ngcontent-jrx-c95="" className="popular-today-heading">
                    <div _ngcontent-jrx-c95="">
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/evo.svg"
                        alt="Popular Games_Kheloyaar360"
                      />
                      <span _ngcontent-jrx-c95="">Evolution (Intl Casino)</span>
                    </div>
                     <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                      <Link
                        _ngcontent-jrx-c95=""
                        className="see-all-a"
                        to={'/jiliAll'}
                        href="https://kheloyaar360.net/casinos/games/POPULAR"
                        
                      >
                        See All
                        <svg
                          _ngcontent-jrx-c95=""
                          className="svg-inline--fa fa-arrow-right fa-w-14 iconArrow"
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fas"
                          data-icon="arrow-right"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 448 512"
                          data-fa-i2svg=""
                        >
                          <path
                            fill="currentColor"
                            d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
                          ></path>
                        </svg>
                      </Link>
                    </div> 
                  </div>
                  <SliderContainer CurrentSlider={{ token, games: evolution }} />
                </div> */}


                {/* casino games */}
                {/* <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                  <div _ngcontent-jrx-c95="" className="popular-today-heading">
                    <div _ngcontent-jrx-c95="">
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/Casino.svg"
                        alt="Popular Games_Kheloyaar360"
                      />
                      <span _ngcontent-jrx-c95="">Casino Games</span>
                    </div>
                    <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                      <Link
                        _ngcontent-jrx-c95=""
                        className="see-all-a"
                        to={'/jiliAll'}
                        href="https://kheloyaar360.net/casinos/games/POPULAR"
                        
                      >
                        See All
                        <svg
                          _ngcontent-jrx-c95=""
                          className="svg-inline--fa fa-arrow-right fa-w-14 iconArrow"
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fas"
                          data-icon="arrow-right"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 448 512"
                          data-fa-i2svg=""
                        >
                          <path
                            fill="currentColor"
                            d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
                          ></path>
                        </svg>
                      </Link>
                    </div> 
                  </div>
                  <SliderContainer CurrentSlider={{ token, games: casino }} />
                </div> */}

                {/* < ScrollableContent /> */}

                <div className="px-1">
                  <Racing />
                </div>

                <div className="row px-1 mt-2">
                  <div className="col-lg-12 mb-0">
                    <img src="/assets/images/banner21.webp" className="img-fluid rounded-xl" />
                  </div>
                </div>

                <div className="row mt-2 px-5 gap-1 pt-4 mx-auto" style={{ backgroundColor: isSmallScreen ? "var(--dark-theme-color-navbar)" : "var(--dark-theme-dark-blue-variant)", justifyContent: 'center', }}>
                  <div className="col-lg-1 col-2 col-md-2 my-auto">
                    <img src="assets/images/footer1.png" className="img-fluid" />
                  </div>
                  <div className="col-lg-1 col-2 col-md-2 my-auto">
                    <img src="assets/images/footer2.png" className="img-fluid" />
                  </div>
                  <div className="col-lg-1 col-2 col-md-2 my-auto">
                    <img src="assets/images/footer3.png" className="img-fluid" />
                  </div>
                  <div className="col-lg-1 col-2 col-md-2 my-auto">
                    <img src="assets/images/footer4.png" className="img-fluid" />
                  </div>
                  <div className="col-lg-1 col-2 col-md-2 my-auto">
                    <img src="assets/images/footer5.png" className="img-fluid h-100 w-50" />
                  </div>
                  <div className="col-lg-1 col-2 col-md-2 my-auto">
                    <img src="assets/images/footer6.png" className="img-fluid" />
                  </div>
                  <div className="col-lg-1 col-2 col-md-2 my-auto">
                    <img src="assets/images/footer7.png" className="img-fluid" />
                  </div>
                  <div className="col-lg-1 col-2 col-md-2 my-auto">
                    <img src="assets/images/footer8.png" className="img-fluid" />
                  </div>
                  <div className="col-lg-1 col-2 col-md-2 my-auto">
                    <img src="assets/images/footer9.svg" className="img-fluid" />
                  </div>
                  <h6 className="fw-bold text-center mb-0" style={{ fontSize: "11px", color: isSmallScreen ? 'var(--dark-theme-card-bg-light)' : "var(--dark-theme-color-navbar)" }}>You must be over 18 years old, or the legal age at which gambling or gaming activities are allowed under the law or jurisdiction that applies to you. You must reside in a country in which access to online gambling to its residents.</h6>
                </div>

                {window.innerWidth <= 768 && <MarqueeBottom />}
              </div>
            </div>
          </div>
        </app-landing-page-new>


        <div className="slider-container"></div>
      </div>
    </app-root>
  );
};
